import * as React from 'react';
import { flow, get, map } from 'lodash';
import { formValueSelector, InjectedFormProps, reduxForm } from 'redux-form';
import { IMtaActions, IMtaFormNames, IMtaState, PageForm } from '../../../../../../../../services/mta/models';
import { connect } from 'react-redux';
import { IStore } from '../../../../../../../../redux/IStore';
import { bindActionCreators } from 'redux';
import { mtaActions } from '../../../../../../../../services/mta/actions';
import { actions as brandingActions } from '../../../../../../../../services/branding/reducer';
import { Button, Form, Grid, OverlayTrigger, Popover } from 'react-bootstrap';
import { FaInfoCircle, FaSpinner } from 'react-icons/fa';
import { IBrandingActions } from '../../../../../../../../services/branding/models';
import * as Commonmark from 'react-commonmark';
import { MTACardHeader } from '../Components/MTACardHeader';
import { MTAButtons } from '../../../MTAButtons';
import { Link } from 'react-router-dom';
import { MTATripDurationSelector } from '../Components/MTATripDurationSelector';

interface MTAChangeDestinationFormProps extends InjectedFormProps<any> {
  mta: IMtaState;
  formValues: any;
  selectedPolicy: any;
  actions: {
    branding: IBrandingActions;
    mta: IMtaActions
  };

  renderDefinition(name: string, useProvidedString?: boolean): any;
}

class MTAChangeTripDurationForm extends React.Component<MTAChangeDestinationFormProps, any> {

  constructor(props) {
    super(props);
    const { dispatch, change, formValues } = props;
    dispatch(change('page', PageForm.MTA_CHANGE_TRIP_DURATION));
    window.scrollTo(0, 0);
    this.state = {
      allowContinue: false,
      originalSelected: parseInt(get(formValues, 'metadata.max_trip_duration'), 10)
    }
  }

  public handleSubmit = () => {
    const { actions } = this.props;

    Promise.all([
      actions.mta.calculateMtaPremiums(),
    ]).then((data) => {
      actions.mta.addEndorsements();
      actions.mta.handleMTASubmit();
    });
  }

  private handleOnchange = (selectedValue) => {
    const selection = parseInt(selectedValue, 10);
    this.setState({ allowContinue: this.state.originalSelected !== selection })
  }

  render() {
    const { mta, handleSubmit, submitting, submitFailed, valid, actions, formValues } = this.props;
    const { allowContinue } = this.state;
    const product = actions.branding.getProduct();
    const isLoading = mta.isLoading;
    const selectedDuration = parseInt(get(formValues, 'metadata.max_trip_duration', ''), 10);

    const annualTripDuration = map(get(product, 'metadata.annual_trip_durations', {}), (name, key) => {
      return {
        label: name,
        value: parseInt(key, 10),
      };
    });

    const popoverClickRootCloseTripExtension = (
      <Popover id="popover-trigger-click-root-close-trip-extension" title="TripExtension">
        <Commonmark
          source={'Annual Multi-Trip policies cover multiple trips of up to 31 days per trip as standard. You can increase the maximum trip duration for the policy term, either up to 45 days or up to 60 days per trip.'}/>
      </Popover>
    );

    const submitButton = (
      <Button
        bsStyle="primary"
        type="submit"
        className="medium-width pull-right secondary-button"
        disabled={submitting || (submitFailed && !valid || !valid || isLoading) || !allowContinue}>
        {isLoading && (
          <FaSpinner className="fa-spin"/>
        )}
        APPLY CHANGES
      </Button>
    )

    const subtext = (
      <div>What is your maximum trip length?
        <span>
          <OverlayTrigger
            trigger="click"
            rootClose={true}
            placement="bottom"
            overlay={popoverClickRootCloseTripExtension}
          ><FaInfoCircle className="info-btn dark_blue"/>
          </OverlayTrigger>
        </span>
      </div>
    )

    const goBackButton = (
      <Link to="/account/summary">
        <Button
          bsStyle={'primary'}
          className={'secondary-button'}>
          GO BACK
        </Button>
      </Link>
    )

    return (
      <>
        <Form horizontal={true} onSubmit={handleSubmit(this.handleSubmit)} autoComplete="off">
          <div className="admiral-card" style={{ marginTop: '20px' }}>
            <MTACardHeader
              text={'Update your Maximum Trip Length below'}
              subtext={subtext}
              icon={'calendar3'}
              border={true}
            />
            <div className="body">
              <Grid fluid={true}>
                <MTATripDurationSelector
                  annualTripDuration={annualTripDuration}
                  selectedDuration={selectedDuration}
                  handleChange={this.handleOnchange}
                />
              </Grid>
            </div>
          </div>
          <div className={'mt-30'}/>
          <MTAButtons button1={goBackButton} button2={submitButton}/>
        </Form>
      </>
    )
  }
}

let selector;

export default flow([
  reduxForm({
    form: IMtaFormNames.COVER_DETAILS,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
  }),
  (component) => {
    selector = formValueSelector(IMtaFormNames.COVER_DETAILS);
    return component;
  },
  connect(
    (state: IStore) => {
      const values = selector(
        state,
        'data.attributes',
      );
      return {
        mta: state.mta,
        selectedPolicy: state.mta.selectedPolicy,
        formValues: values,
      };
    },
    (dispatch) => ({
      actions: {
        mta: bindActionCreators({ ...mtaActions }, dispatch),
        branding: bindActionCreators({ ...brandingActions }, dispatch),
      },
    }),
  ),
])(MTAChangeTripDurationForm);
